module.exports = __webpack_public_path__ + "reg-1-icon.png?59548925ff445ecdf78ab642ae235ac6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reg-1-icon.png
// module id = 205
// module chunks = 0